module.exports = __webpack_public_path__ + "media/images/pic/teachers-e6e81ef84791f48d832d4d79336ec820.jpeg";